import React from "react";
import { Button } from "react-bootstrap";

export function FooterTemplate({
  closeTitle,
  submitTitle,
  onClose,
  onSubmit,
  submitDisable
}) {
  return (
    <React.Fragment>
      {/* <Button variant="secondary" onClick={onClose}>
        {closeTitle || `Close`}
      </Button>*/}
      <Button
        variant="primary"
        onClick={onSubmit}
        disabled={submitDisable}
        className={submitDisable ? "disable-btn" : ""}
        style={{ border: submitDisable ? "1px transparent" : null }}
      >
        {submitTitle || `Save Changes`}
      </Button>
    </React.Fragment>
  );
}
